// """  URL for updating current user profile
//
//      endpoint: /profile
//
//      put: Sets new user`s profile
// """
export const GetMyProfileUrl = () => {
  return '/profile'
}
export const GetProfileId = (profileId) => {
  return `/profile/${profileId}`
}
export const PostProfileMedia = (profileId, category, label) => {
  return `/profile/${profileId}/media?type=${category}&name=${label}`
}

export const DeleteProfileMediaByIndex = (profileId, index) => {
  return `/profile/${profileId}/media/${index}`
}

export const LastUpdatedTimestampUrl = profileId => {
  return `/profile/${profileId}/timestamp`
}
export const GetNoteUrl = () => {
  return '/notes'
}
export const DeleteNote = (noteId) => {
  return `/notes/${noteId}`
}
export const UpdateNote = (noteId) => {
  return `/notes/${noteId}`
}
